export const sectionTabs = Object.freeze({
  pages: 'TabSubject', dialogs: 'TabDialogs', reading: 'TabReading', words: 'TabWord', listening: 'TabAudio',
  video: 'TabVideo', animation: 'TabAnimationVideo', questions: 'TabQuestion',
  test: 'TabTest', teacherEvaluation: 'TabTeacherResult', content: 'TabCustom',
});

export const sectionIcons = Object.freeze({
  pages: 'book', dialogs: 'chat-dots', reading: 'bookmark', words: 'x-diamond', listening: 'headphones',
  video: 'play-btn', animation: 'play-btn', questions: 'patch-question',
  test: 'card-checklist', teacherEvaluation: 'person-video3', content: 'file-earmark-text',
});

export function customSectionContents(book, sectionId) {
  return (book?.contents || []).filter(c => c.bookSectionId === sectionId && c.contentType === 20)
    .slice().sort((a, b) => a.index - b.index);
}

const isDialog = content => [10, 11, 12].includes(content.contentType);
export function pageSectionContents(book) {
  return (book?.contents || []).filter(c => c.contentType !== 20 && [1, 2].includes(c.fileType) &&
    (!isDialog(c) || c.bookSectionId == null || book.sections == null ||
      book.sections.some(s => s.id === c.bookSectionId && s.rendererType === 'pages')));
}
export function dialogSectionContents(book, sectionId) {
  return (book?.contents || []).filter(c => isDialog(c) && c.bookSectionId === sectionId && [1, 2].includes(c.fileType));
}

export function visibleBookSections(book, labels) {
  if (!book) return [];
  const legacy = (book.contents || []).filter(c => c.contentType !== 20);
  const pages = pageSectionContents(book);
  const available = {
    pages: pages.some(c => [1, 2, 3, 6, 10, 11, 12].includes(c.contentType)),
    reading: pages.some(c => c.contentType === 13),
    words: !!book.words?.length,
    listening: legacy.some(c => c.fileType === 4),
    video: legacy.some(c => c.fileType === 5 && c.contentType === 4),
    animation: legacy.some(c => c.fileType === 5 && c.contentType === 7),
    questions: !!book.questions?.length, test: !!book.tests?.length, teacherEvaluation: true,
  };
  // Compatibility with older API responses; an explicit empty list stays empty.
  const sections = book.sections ?? Object.keys(available).map((key, index) => ({
    id: key, key, rendererType: key, title: labels[key], sequence: index,
    group: ['test', 'teacherEvaluation'].includes(key) ? 'after' : 'before', isActive: true,
  }));
  return sections.filter(s => s.isActive && !s.isDeleted && (s.rendererType === 'content'
    ? customSectionContents(book, s.id).length > 0 : s.rendererType === 'dialogs'
      ? dialogSectionContents(book, s.id).length > 0 : available[s.rendererType]))
    .slice().sort((a, b) => a.sequence - b.sequence || String(a.id).localeCompare(String(b.id), undefined, {numeric: true}));
}

export function visibleBookGroups(book, labels) {
  const sections = visibleBookSections(book, labels);
  if (book?.groups != null) {
    return book.groups.filter(g => g.isActive && !g.isDeleted).slice()
      .sort((a, b) => a.sequence - b.sequence || a.id - b.id)
      .map(g => ({...g, sections: sections.filter(s => s.groupId === g.id)}))
      .filter(g => g.sections.length);
  }
  return [{id: 'before', title: labels.beforeLesson}, {id: 'after', title: labels.afterLesson}]
    .map(g => ({...g, sections: sections.filter(s => s.group === g.id)})).filter(g => g.sections.length);
}
